import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { WrapperField } from '../../../../../components/InputField/WrapperField';
import { DialogContext } from '../../../../../store/context/DialogContext';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import ButtonGroupNew from '../../BusinessLiteForms/components/ButtonGroupNew';
import { getNextStep, getVisibleWizardFieldOrder, WIZARD, WIZARD_NUM } from '../helper';

const BusinessType = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    isForEDD,
    handleChange,
    handlePrev,
    applicationForm,
    editMode,
    setData,
    formType
}) => {
    const { showError } = useContext(DialogContext);
    const { t } = useTranslation();

    const checkNext = () => {
        const visibleFieldOrder = getVisibleWizardFieldOrder({
            fields: iPlusFields,
            wizard,
            data,
        });

        for (const fieldPath of visibleFieldOrder) {
            const fieldError = _.get(errors, fieldPath);
            if (fieldError) {
                setHasError(true);
                if (fieldError) {
                    showError(fieldError);
                    return false;
                }
            }
        }

        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: getNextStep(wizard, applicationForm, data, editMode) });
        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    };

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            updatedErrors[field] = errorMsg;
            return updatedErrors;
        });
    };

    return (
        <div className="row">
            <div className="col-12">

                <div className='mb-3'>

                    <p className='pt-3'>
                        For the purposes of this application, FV Bank considers all of the following to be Money Services Businesses, whether a license is required or not in your jurisdictions. (Exchanges, OTC Providers, Liquidity Providers, Wallet Providers, Non Bank Financial Institutions, VASPS, DLT's EMI's, PSD license holders, Brokers, Remittance Providers and FX Providers.)
                    </p>

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["businesses"]}
                        dataObj={data}
                        className="my-1 col-sm-12 d-flex"
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('businesses', errorMsg)}
                        isForEDD={isForEDD}
                    />

                    <WrapperField
                        disabled={asLabel}
                        className=""
                        jsonField={cyclosFields["businessOther"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('businessOther', errorMsg)}
                        isForEDD={isForEDD}
                    />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["sourceOfFunds"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('sourceOfFunds', errorMsg)}
                        className="my-1 col-sm-12 d-flex"
                        isForEDD={isForEDD}
                    />
                </div>

                <div className='mt-4'>
                    <ButtonGroupNew
                        onNextClick={handleSubmit}
                        onBackClick={() => { handlePrev() }}
                        step={WIZARD_NUM.BusinessType}
                        showPageNum={false}
                        pageNum={WIZARD_NUM.BusinessType}
                        hideSubmitButton={hideButtons}
                        asLabel={false}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default observer(BusinessType);
